import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsNotEmpty, IsNumberString, IsOptional, IsString, Matches, MaxLength, ValidateNested } from "class-validator";
import { ShiftsEnum } from "@gtpl/shared-models/common-models";

export class PeelingSamplesDto {
  @ApiProperty()
  peelingSamplesId:number  
  @ApiProperty()
  peelingId:number;
  @ApiProperty()  
  sampleNo:number;
  @ApiProperty()
  temperature:number;
  @ApiProperty()
  count:number;
  @ApiProperty()
  typeOfCut:string;
  @ApiProperty()
  bigToSmallRatio:number;
  @ApiProperty()
  legsVeinsShell:string;
  @ApiProperty()
  improperCutting:string;
  @ApiProperty()
  blackTailBlackSpot:string;
  @ApiProperty()
  brokenUnstable:string;
  @ApiProperty()
  deteriorationDecomposition:string;
  @ApiProperty()
  otherObjectionableDefects:string;
  @ApiProperty()
  checkedBy:string;
  @ApiProperty()
  verifiedBy:string;
  @ApiProperty()
  remarks:string;
  
  @ApiProperty()
  isActive: boolean;
  createdAt: Date;
  @ApiProperty()
  createdUser: string;
  updatedAt: Date;
  @ApiProperty()
  updatedUser: string;
  versionFlag: number;

}